module.exports = __webpack_public_path__ + "img/home-personas-2.bda6434.webp";